import { connect } from 'react-redux';
import { navigate } from '../reducers/navigator.reducers';
import {
  onLoadCourse,
  onLoadCourses,
  onCloseCompletedDialog,
  loadDefaultBulletinBoard,
  getPinnedContentAction,
} from '../reducers/course.reducers';
import {
  onLoadChecklists,
  onLoadChecklistRuns,
  onLoadChecklistToDos,
} from '../reducers/checklist.reducers';
import {
  loadUserInfo,
  onLoadConfiguration,
  loadUserRolesAction,
  loadUserGroupsForUserAction,
} from '../reducers/auth.reducers';
import {
  onLoadTests,
  onCloseCompletedDialog as onCloseTestCompletedDialog,
  onLoadResults,
  onLoadExams,
} from '../reducers/test.reducers';
import { loadNotificationCenterEntriesAction } from '../reducers/notification.reducers';
import { logout } from '../reducers/auth.reducers';

import Main from './main';

const mapStateToProps = (state) => ({
  title: state.navigator.title,
  selectedCourseId: state.courses.selectedCourseId,
  bulletinBoard: state.courses.bulletinBoard,
  user: state.authentication.user,
  config: state.authentication.config,
});

const mapDispatchToProps = (dispatch) => ({
  navigate: (route) => dispatch(navigate(route)),
  onLogout: () => {
    dispatch(logout());
    dispatch(navigate({ route: '/' }));
  },
  onLoadCourses: () => dispatch(onLoadCourses()),
  onLoadChecklists: () => {
    dispatch(onLoadChecklistRuns());
    dispatch(onLoadChecklistToDos());
    dispatch(onLoadChecklists());
  },
  onCloseCompletedDialog: () => {
    dispatch(onCloseCompletedDialog());
    dispatch(onCloseTestCompletedDialog());
  },
  onLoadTests: () => dispatch(onLoadTests()),
  onLoadResults: () => dispatch(onLoadResults()),
  onCourseSelected: (courseId) => {
    dispatch(onLoadCourse(courseId));
  },
  loadUserInfo: () => dispatch(loadUserInfo()),
  loadNotifications: () => dispatch(loadNotificationCenterEntriesAction()),
  loadUserRoles: () => dispatch(loadUserRolesAction()),
  loadUserGroups: () => dispatch(loadUserGroupsForUserAction()),
  loadExams: () => dispatch(onLoadExams()),
  loadConfig: () => dispatch(onLoadConfiguration('whitelabel')),
  loadBulletinBoard: () => dispatch(loadDefaultBulletinBoard()),
  getPinnedContentAction: (boardId, sortFilterDto) =>
    dispatch(getPinnedContentAction({ boardId, sortFilterDto })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);



// WEBPACK FOOTER //
// ./src/app/main/main.container.js